import React, { useState } from "react";
import { IoCloseCircleOutline } from "react-icons/io5";


interface IProps {
  plans: any[];
  setPlans: React.Dispatch<React.SetStateAction<any[]>>;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const MinimalPlans = ({ plans, setPlans, setShow }: IProps) => {
  const [localPlans, setLocalPlans] = useState(plans);
  return (
    <>
      {localPlans.map((plan, i) => {
        return (
        <div key={plan.sptc_id} className="py-2 border-b flex items-start justify-between">
          <div className="flex items-center justify-start space-x-2">
            <div>{`${i+1}.`}</div>
            <div className="text-gray-700 text-sm">
              <div className="text-primary">
                {plan.plan_name}
              </div>
              <div>
                {plan.customer_name}
              </div>
              <div>
                {plan.property.address} {plan.property.city} {plan.property.state} {plan.property.zipcode}
              </div>
            </div>
          </div>
          {/* Button to remove selected plan */}
          <button 
            onClick={() => {
              const updatedPlans = localPlans.filter(p => p.sptc_id !== plan.sptc_id);
              setLocalPlans(updatedPlans);
              setPlans(updatedPlans);
              if (updatedPlans.length === 0) {
                setShow(false);
              }
            }}
            className="text-red-500 hover:bg-red-500 hover:text-white rounded-full"
          >
            <IoCloseCircleOutline size={20} />
          </button>
        </div>
      )})}
    </>
  )
}

export default MinimalPlans;